import { render, staticRenderFns } from "./SourceOrder.vue?vue&type=template&id=5684c4c6&scoped=true&lang=pug&"
import script from "./SourceOrder.vue?vue&type=script&lang=js&"
export * from "./SourceOrder.vue?vue&type=script&lang=js&"
import style0 from "./SourceOrder.vue?vue&type=style&index=0&id=5684c4c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5684c4c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VCol,VRow,VTextField})
